document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('birthday-form');
  const responseDiv = document.getElementById('birthday-response');
  const hoverContent = document.querySelector('.hover-content');
  const submitButton = form.querySelector('button[type="submit"]'); // Assuming the button inside the form
  const loadingIndicator = document.createElement('div');
  loadingIndicator.innerText = 'Processing...';
  loadingIndicator.style.display = 'none'; // Hide initially
  responseDiv.parentNode.insertBefore(loadingIndicator, responseDiv);

  if (!form) {
    console.log('Form not found!');
    return;
  } else {
    console.log('Form found!');
  }

  async function submitBirthday(event) {
    event.preventDefault();
    console.log('Form submission started');

    const day = form.querySelector('#birthday-day').value;
    const month = form.querySelector('#birthday-month').value;
    const year = form.querySelector('#birthday-year').value;
    const customerId = form.querySelector('#customer-id').value;

    // Validate the date
    if (!day || !month || !year) {
      responseDiv.innerText = 'Please fill in all fields.';
      return;
    }

    const data = {
      day: day,
      month: month,
      year: year,
      customerId: customerId
    };

    console.log('Form data:', data);

    // Show loading indicator and disable submit button
    loadingIndicator.style.display = 'block';
    submitButton.disabled = true;
    responseDiv.innerText = ''; // Clear previous messages

    try {
const response = await fetch('https://submitbirthday-wdi67ghera-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json().catch(() => {
        throw new Error('Invalid JSON response');
      });

      console.log('Server response:', result);
      
      if (result.success) {
        responseDiv.innerText = 'Data urodzin została dodana i 40 punktów zostało dodane do Twojego konta!';
        form.style.display = 'none'; // Hide the form
        hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Completed</div>';
      } else {
        responseDiv.innerText = `Error: ${result.error}`;
      }
    } catch (error) {
      console.log('Error:', error);
      responseDiv.innerText = `Error: ${error.message}`;
    } finally {
      // Hide loading indicator and re-enable the submit button
      loadingIndicator.style.display = 'none';
      submitButton.disabled = false;
    }
  }

  form.addEventListener('submit', submitBirthday);
});